import { gql } from '@apollo/client';

export const GET_WIDGET_CONFIGURATION_CHAT_INTERFACE = gql`
  query GetWidgetConfigurationForChatbot($businessIdFromChatbot: String) {
    getWidgetConfigurationForChatbot(businessIdFromChatbot: $businessIdFromChatbot) {
      chatbot {
        displayName
        initialMessages
        theme
        messageColor
        buttonColor
        profile
        icon
        faqs {
          id
          question
        }
      }
      leads {
        enableOnSite
        title
        name {
          text
          isEnable
        }
        email {
          text
          isEnable
        }
        phone
      }
      company
      isDeleted
      createdBy
      updatedBy
    }
  }
`